import React, { useEffect, useState } from "react";
import { Radio } from "antd";

import Style from "../questionItem.module.scss";
import { getDanxuanSelectId } from "../../../utils/filter";
import { RadioChangeEvent } from "antd/lib/radio";

interface IProps {
    list: {
        answerId: number;
        content: string;
        isChoose: "0" | "1";
        isRight: "0" | "1";
    }[];
    homeworkState: number;
    onChange: (value: number) => void;
}

export const Single = ({ onChange, list, homeworkState }: IProps) => {
    let [value, setValue] = useState(getDanxuanSelectId(list));

    useEffect(() => {
        setValue(getDanxuanSelectId(list));
    }, [list]);

    const handleChange = (event: RadioChangeEvent) => {
        if (homeworkState === 2) return;
        onChange(event.target.value);
    };

    return (
        <Radio.Group onChange={handleChange} value={value}>
            {list.map(item => (
                <div key={item.answerId} className={Style.option}>
                    <Radio
                        className={
                            homeworkState === 2 && item.isRight === "1"
                                ? Style.success
                                : undefined
                        }
                        value={item.answerId}>
                        <div
                            dangerouslySetInnerHTML={{ __html: item.content }}
                            className={Style.richText}
                        />
                    </Radio>
                </div>
            ))}
        </Radio.Group>
    );
};
